export default __webpack_public_path__ + "static/media/team.b8284593.jpeg";